module.exports = __webpack_public_path__ + "static/img/icon3-10.1877bea9.png";